export class ConnectionEntities {
        id: number; 
        name: string; 
        class: string; 
        icon?: string;
}
